import { useContext, useEffect, useState } from 'react';
import { CarouselContext } from 'pure-react-carousel';

export { CarouselProvider as MediaGalleryCarouselProvider } from 'pure-react-carousel';

export function useMediaGalleryCarouselContext(): Readonly<{
  currentSlideIndex: number;
  totalSlidesCount: number;
  setCurrentSlideByIndex: (targetIndex: number, disableAnimation: boolean) => void;
  enableAnimation: () => void;
}> {
  const carouselContext = useContext(CarouselContext);
  const [currentSlideIndex, syncCurrentSlideIndex] = useState(carouselContext.state.currentSlide);
  const enableAnimation = () => {
    if (carouselContext.state.disableAnimation === true) {
      carouselContext.setStoreState({ disableAnimation: false });
    }
  };
  useEffect(() => {
    const onChange = () => {
      if (carouselContext.state.disableAnimation === true && window.addEventListener) {
        window.addEventListener('touchstart', enableAnimation, { once: true });
      }
      syncCurrentSlideIndex(carouselContext.state.currentSlide);
    };
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carouselContext]);

  return {
    currentSlideIndex,
    totalSlidesCount: carouselContext.state.totalSlides,
    setCurrentSlideByIndex: (targetIndex: number, disableAnimation: boolean = false) => {
      carouselContext.setStoreState({ disableAnimation });
      carouselContext.setStoreState({ currentSlide: targetIndex });
    },
    enableAnimation,
  };
}
